export default "__VITE_ASSET__BMpgBI8g__"